'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _TooltipArrow;
var _excluded = ["className", "sideOffset", "children"];
import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipArrow = function TooltipArrow(props) {
  return /*#__PURE__*/_jsx(TooltipPrimitive.Arrow, _objectSpread({
    className: "tw-block tw-fill-neutral-dark-700 dark:tw-fill-neutral-light-200"
  }, props));
};
TooltipArrow.displayName = TooltipPrimitive.Arrow.displayName;
var TooltipContent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$sideOffset = _ref.sideOffset,
    sideOffset = _ref$sideOffset === void 0 ? 15 : _ref$sideOffset,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(TooltipPrimitive.Content, _objectSpread(_objectSpread({
    ref: ref,
    sideOffset: sideOffset,
    className: cn('tw-relative tw-bg-neutral-dark-700 tw-rounded-0.4 tw-max-w-28 dark:tw-bg-neutral-light-200 tw-text-center tw-font-body5 tw-font-normal tw-text-neutral-light-100 dark:tw-text-neutral-light-800 tw-p-0.8 data-[side=bottom]:tw-slide-in-from-top-2 tw-z-5 tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2 tw-whitespace-normal', className)
  }, props), {}, {
    children: [_TooltipArrow || (_TooltipArrow = /*#__PURE__*/_jsx(TooltipArrow, {})), children]
  }));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
/**
 * @deprecated Use `SimpleTooltip` instead. `TooltipWrapper` has several issues:
 * `align` is required, `value` only accepts strings, and `asChild` defaults to
 * `false` which causes nested `<button>` problems. `SimpleTooltip` fixes all of these.
 */
var TooltipWrapper = function TooltipWrapper(_ref2) {
  var delayDuration = _ref2.delayDuration,
    children = _ref2.children,
    side = _ref2.side,
    value = _ref2.value,
    asChild = _ref2.asChild,
    align = _ref2.align;
  return /*#__PURE__*/_jsx(TooltipProvider, {
    children: /*#__PURE__*/_jsxs(Tooltip, {
      delayDuration: delayDuration,
      children: [/*#__PURE__*/_jsx(TooltipTrigger, {
        asChild: asChild,
        children: children
      }), /*#__PURE__*/_jsx(TooltipContent, {
        align: align,
        side: side,
        children: value
      })]
    })
  });
};
var SimpleTooltip = function SimpleTooltip(_ref3) {
  var value = _ref3.value,
    children = _ref3.children,
    side = _ref3.side,
    _ref3$align = _ref3.align,
    align = _ref3$align === void 0 ? 'center' : _ref3$align,
    delayDuration = _ref3.delayDuration,
    _ref3$asChild = _ref3.asChild,
    asChild = _ref3$asChild === void 0 ? true : _ref3$asChild,
    className = _ref3.className;
  return /*#__PURE__*/_jsx(TooltipProvider, {
    children: /*#__PURE__*/_jsxs(Tooltip, {
      delayDuration: delayDuration,
      children: [/*#__PURE__*/_jsx(TooltipTrigger, {
        asChild: asChild,
        children: children
      }), /*#__PURE__*/_jsx(TooltipContent, {
        align: align,
        side: side,
        className: className,
        children: value
      })]
    })
  });
};
export { SimpleTooltip, Tooltip, TooltipArrow, TooltipContent, TooltipProvider, TooltipTrigger, TooltipWrapper };